import {EntityType} from "../@core/entityType";
import {Operation} from "reactcoregk";

export const entityType = EntityType.Tactic;
export const entityOperations = [
  Operation.create,
  Operation.update,
  Operation.delete,
];
